import { useState } from 'react'
import './auth.css'

export default function AuthenticateUser({ signUserIn }) {

    const [authcode, setAuthcode] = useState('')

    return (
        <div id="auth-wrapper">
            <div id="auth-card">
                <h2>Sign In</h2>
                <br/>
                <div>
                    <input 
                        placeholder='Authorization Key'
                        value={authcode}
                        onChange={e => setAuthcode(e.target.value)}
                    />
                </div>
                <br/>
                <button onClick={() => signUserIn(authcode)}>Unlock App</button>
            </div>
        </div>
    )
}